import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject } from '@angular/core';

import { SpinnerService } from '../../core/services/spinner.service';

@Component({
  selector: 'dmp-spinner-overlay',
  imports: [AsyncPipe],
  templateUrl: './spinner-overlay.component.html',
  styleUrl: './spinner-overlay.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SpinnerOverlayComponent {
  readonly visible$ = inject(SpinnerService).visible$;
}
